var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[ 'anno-wrapper', { uppercase: _vm.uppercase, italic: _vm.italic, bold: _vm.bold } ],style:({
  color: _vm.color,
  'font-size': _vm.size,
  'font-family': _vm.font,
  'letter-spacing': _vm.computedSpacing,
  margin: _vm.margin,
  'display': 'block',
  'font-weight': _vm.computedWeight,
  'word-spacing': _vm.wordSpacing,
  'word-break': _vm.wordBreak
})},[(_vm.$slots.default)?_c('span',{class:['anno-content', { strikethrough: _vm.strikethrough, overline: _vm.overline, underline: _vm.underline }],style:({
      'text-decoration': _vm.textDecoration
    })},[_vm._t("default")],2):(_vm.text)?_c('span',{class:['anno-content', { strikethrough: _vm.strikethrough, overline: _vm.overline, underline: _vm.underline }],style:({
      'text-decoration': _vm.textDecoration
    })},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }